import { createContext, ReactNode } from 'react'

export interface ProductTileCTAContextValue {
  showButton: (productId: string) => boolean
  onButtonClick: (productId: string) => void
  createButtonLabel: (productId: string) => ReactNode
}

const ProductTileCTAContext = createContext<
  ProductTileCTAContextValue | undefined
>(undefined)

export default ProductTileCTAContext
